<template>
  <div id="anstract-detail-dialog">
    <ipub-model title="Abstract"
                width="1000px"
                class="copyright-documents"
                :visable="isVisable"
                @cancel="cancel"
                :showFooter="false">
      <div class="ipub-p2">
        {{abstract}}
      </div>
    </ipub-model>
  </div>
</template>

<script>
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    abstract: {
      type: String,
      default: '',
    },
  },
  data () {
    return {

    }
  },

  watch: {
    isVisable: {
      handler (val) {

      },
      immediate: true
    },
    abstract: {
      handler (val) {

      },
      immediate: true
    },
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
#anstract-detail-dialog {
}
</style>
